module.exports = __webpack_public_path__ + "static/media/cattle.70f921cb.jpg";